import { IconLatestResearch } from '@medifind/icons';
import { useRouter } from '@medifind/router';
import AdWrapper from './adWrapper';

const FindADoctorAd = ({ isUSPrescriber = true, ...props }) => {
  const router = useRouter();
  return (
    <AdWrapper
      {...props}
      icon={<IconLatestResearch showBackground={false} showBoxShadow={false} width={41} height={50} color={'#645da2'} padding={false} />}
      title={`Looking for the best ${isUSPrescriber ? 'doctor' : 'expert'} for you?`}
      onClick={() => router.history.push(`/find-a-doctor?isStarted=true`)}
      buttonText={'Start Here'}
    />
  );
};

export { FindADoctorAd as default, FindADoctorAd };
